
<template>
  <div>
     <!-- fullscreen  -->
    <v-dialog
      v-model="dialog"
      scrollable
      persistent
      max-width="1000px"
      transition="dialog-transition"
    >
      <v-card style="border-radius:12px">
        <v-card-title primary-title>
          <div class="headline mb-0">Formulários deste departamento com inconformidades</div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          requisição para mostrar todos form com alguma inconformidade desse dept, no tal periodo de tempo 
          <div class="title">
            Departamento: <span>{{department.dep_name || department.name}}</span>
          </div>
          
          <v-data-iterator :loading="loading_data" :items="forms" :search="search" :options.sync='options' :server-items-length='total_data' >
            <template v-slot:loading>
              <card-loading-transparent v-if="loading_data"></card-loading-transparent>
              <!-- <v-text-field v-model="search" prepend-icon="mdi-magnify" label="Encontrar"></v-text-field> -->
            </template>

            <template v-slot:default="{ items, isExpanded, expand }">
              <v-card style="border-radius: 8px" class="mb-2"
                @click="showDoneForm(item)"
                v-for="(item, idx) in items"
                :key="'cdi'+idx"
              >
                <v-card-text :class="['pa-3']">
                  <v-row justify="space-between" align="center">
                    <v-col cols="12" sm="8" md="8" align="start" class="py-0">
                      <!-- <div v-if="item.idb_id"> -->
                      <!-- </div> -->
                      <div class="subtitle-1 font-weight-bold mr-2">
                        <!-- <v-icon color='red' v-if="item.idb_id">mdi-cellphone-play</v-icon> -->
                        {{ item.name }} 
                      </div> 
                      <!-- remover essa feature para lançar para farmax semana que vem -->
                      <div v-if="false" v-for="a in item.first_three_answers" :key="a.id">
                        <span class="text-decoration-underline"> {{ a[0] }}</span> : {{a[1]}}
                      </div>
                      <v-row justify="start" class="px-3">
                        <v-tooltip bottom color="black">
                          <template v-slot:activator="{on}">
                            <v-chip pill small v-on="on" class="my-1 mx-1">
                              <v-avatar left class="secondary">
                                <v-icon dark small>mdi-calendar</v-icon>
                              </v-avatar>
                              <span class="font-weight-bold mr-1">
                                Feito em: 
                              </span>
                              {{new Date(item.done_at).toLocaleDateString('pt-BR', { hour: '2-digit', minute: '2-digit'})}}
                            </v-chip>
                          </template>
                          Feito em
                        </v-tooltip>
                        <v-tooltip bottom color="black">
                          <template v-slot:activator="{on}">
                            <v-chip pill small v-on="on" class="my-1 mx-1">
                              <v-avatar left class="accent">
                                <v-icon dark small>mdi-account-tie</v-icon>
                              </v-avatar>
                              <span class="font-weight-bold mr-1">
                                Por: 
                              </span>
                              {{item.user_name}}
                              <!-- {{new Date(item.done_at).toLocaleDateString('pt-BR', { hour: '2-digit', minute: '2-digit'})}} -->
                            </v-chip>
                          </template>
                          Responsável
                        </v-tooltip>
                      </v-row>
                    </v-col>
                    <v-col cols="12" sm="4" md="4" align="right" class="py-0">
                        <div class="title">Pontuação</div>
                        <div class="title">{{item.score}}%</div>
                      <!-- <v-row justify="end" class="pa-3" align="center"> -->
                      <!-- </v-row> -->
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </template>
          </v-data-iterator>
          <div v-if="loading_data">
            <v-progress-linear color='secondary' :indeterminate="true"></v-progress-linear>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-end">
          <!-- <v-btn text color="error">Cancelar</v-btn> -->
          <v-btn text @click="close" color="secondary">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <dialog-done-form v-if="dialog_df" :done_form_id="df_id" @close='handleClose'></dialog-done-form>

  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Api from '@/api'
import TablePagy from '@/mixins/table_pagination'

export default {
  name: 'DialogDepartment',
  components: { 
    DialogDoneForm: ()=>import('./DialogDoneForm.vue')
  },
  props: {
    dept_id: {
      type: Number,
    },
    department: {
      type: Object,
    },
  },
  mixins: [TablePagy],
  data() {
    return {
      dialog: true,
      forms: [],

      df_id: null,
      dialog_df: false,
    }
  },
  methods: {
    showDoneForm(item){
      this.dialog_df = true
      this.df_id = item.id
    },
    handleClose(){
      this.dialog_df = false
      this.df_id = null
    },
    close() {
      this.dialog = false
      this.$emit('close')
    },
    getData(){
      let filter = {
        // model_id: ,
        id: this.dept_id,
        model_type: 'department',
        date: this.date,
        // size: size || 10,
        // page: page || 1,
      }
      console.log({filter});
      this.getDataFromApi('Dashboard', 'showFailures', 'forms', 'forms', 'total', filter)
    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  mounted () {
    setTimeout(() => {
      this.getData()
    }, 200);
  },
  computed: {
    name() {
      return null 
    },
    ...mapState({
      date: state=>state.FailuresDashboard.date
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>